import authRoles from 'app/authRoles'

export type RolesTypes = keyof typeof authRoles

const hasPermission = (permissions: RolesTypes[], roles: string[]) => {
    let hasPerm = false

    for (let i = 0; i < permissions.length; i += 1) {
        if (roles.includes(authRoles[permissions[i]][0])) {
            hasPerm = true
            break
        }
    }

    return hasPerm
}

export default hasPermission
